import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { PipelineLicenseStakeholderDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-pipeline-license-stakeholder-container',
  templateUrl: './pipeline-license-stakeholder-container.component.html',
  styleUrls: ['./pipeline-license-stakeholder-container.component.scss']
})
export class PipelineLicenseStakeholderContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  pipelinelicensestakeholders$: Observable<PipelineLicenseStakeholderDto[]>;
  loading: boolean;
  isLoadingPipelineLicenseStakeholder$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingPipelineLicenseStakeholder$ = this.gatwayFacade.isLoadingGateway('PipelineLicenseStakeholder');
    this.pipelinelicensestakeholders$ = this.gatwayFacade.loadGateway('PipelineLicenseStakeholder');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePipelineLicenseStakeholder(deletedValue: any) {
    this.gatwayFacade.remove('PipelineLicenseStakeholder', deletedValue);
  }

  // this method control both the create and update

  onSubmitPipelineLicenseStakeholder(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.PipelineLicenseStakeholders;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllPipelineLicenseStakeholder = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllPipelineLicenseStakeholder.push(pullData[i]);
      }
    }

    // check if the addAllPipelineLicenseStakeholder array is not empty, then dispatch the data to the store
    if (addAllPipelineLicenseStakeholder.length > 0) {
      this.gatwayFacade.add('PipelineLicenseStakeholder', addAllPipelineLicenseStakeholder);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('PipelineLicenseStakeholder', allUpdates, ['id']);
    }
  }
}
